import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { VehicleExporterPhotosDto, vehicleExporterPhotoValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface ExporterPhotoAddEditDialogProps {
  disabled?: boolean
  initialValues: VehicleExporterPhotosDto
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
  isLoading: boolean
}

export default function ExporterInformationAddEdit({
  disabled,
  initialValues,
  isLoading,
  onClose,
  onSave,
  open
}: ExporterPhotoAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={vehicleExporterPhotoValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, setFieldValue, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Exporter Photo</DialogTitle>

                  <Grid item xs={12}>
                    <input
                      accept='.png,.jpg,.jpeg'
                      hidden
                      type='file'
                      id='manufacturerLabelImageExporterFileInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('manufacturerLabelImageExporterFile', e.target.files[0])
                        }
                      }}
                    />

                    <Button
                      disabled={isLoading || isSubmitting || disabled}
                      onClick={() => {
                        document.getElementById('manufacturerLabelImageExporterFileInput')?.click()
                      }}
                      variant='contained'
                    >
                      UPLOAD MANUFACTURER LABEL IMAGE (EXPORTER)
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.manufacturerLabelImageExporterFile?.name ??
                        values.manufacturerLabelImageExporterFileName ??
                        'No file uploaded'}
                    </Typography>

                    {errors.manufacturerLabelImageExporterFile && (
                      <Typography color='error' variant='body2'>
                        {errors.manufacturerLabelImageExporterFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <input
                      accept='.png,.jpg,.jpeg'
                      hidden
                      type='file'
                      id='tpmsTelltaleImageExporterFileInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('tpmsTelltaleImageExporterFile', e.target.files[0])
                        }
                      }}
                    />

                    <Button
                      disabled={isLoading || isSubmitting || disabled}
                      onClick={() => {
                        document.getElementById('tpmsTelltaleImageExporterFileInput')?.click()
                      }}
                      variant='contained'
                    >
                      UPLOAD TPMS TELLTALE IMAGE (EXPORTER)
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.tpmsTelltaleImageExporterFile?.name ??
                        values.tpmsTelltaleImageExporterFileName ??
                        'No file uploaded'}
                    </Typography>

                    {errors.tpmsTelltaleImageExporterFile && (
                      <Typography color='error' variant='body2'>
                        {errors.tpmsTelltaleImageExporterFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <input
                      accept='.png,.jpg,.jpeg'
                      hidden
                      type='file'
                      id='odometerImageExporterFileInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('odometerImageExporterFile', e.target.files[0])
                        }
                      }}
                    />

                    <Button
                      disabled={isLoading || isSubmitting || disabled}
                      onClick={() => {
                        document.getElementById('odometerImageExporterFileInput')?.click()
                      }}
                      variant='contained'
                    >
                      ODOMETER IMAGE (EXPORTER)
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.odometerImageExporterFile?.name ?? values.odometerImageExporterFileName ?? 'No file uploaded'}
                    </Typography>

                    {errors.odometerImageExporterFile && (
                      <Typography color='error' variant='body2'>
                        {errors.odometerImageExporterFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <ExplanationAccordion variant='outlined'>
                      The “Exporter” images allowed file types include .png, .jpg, and .jpeg. with a maximum file size of 20 MB.
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={isLoading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton disabled={disabled} loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
